document.addEventListener("DOMContentLoaded", function () {
  const descriptionDiv = document.getElementById("descriptionDiv");
  const toggleText = document.getElementById("toggleText");

  let isExpanded = false; // State to track expansion

  descriptionDiv.addEventListener("click", function () {
    if (isExpanded) {
      // Collapse the div
      descriptionDiv.style.height = "63px"; // Original height
      toggleText.textContent = "Read More";
    } else {
      // Expand the div
      descriptionDiv.style.height = `${descriptionDiv.scrollHeight}px`; // Height required to show all content
      toggleText.textContent = "Read Less";
    }
    isExpanded = !isExpanded;
  });
});
